// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/a53419d1/" + chunkId + "." + __webpack_require__.h() + ".va53419d1.js";
};